import { isString } from '../common';
import toDate from './to-date';

export default function parseDate(intlService, date) {
    var result;
    if (isString(date)) {
        result = intlService.parseDate(date) || toDate(date);
    } else {
        result = toDate(date);
    }
    return result;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-react-gauges/node_modules/@progress/kendo-charts/dist/es/date-utils/parse-date.js
// module id = 970
// module chunks = 29